import { render } from "./PendingTasks.vue?vue&type=template&id=4f82853b"
import script from "./PendingTasks.vue?vue&type=script&lang=js"
export * from "./PendingTasks.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__